// extracted by mini-css-extract-plugin
export default {"textShieldRootV2":"textShieldRootV2___ye7jY","s":"s___IXbgc","m":"m___l50O3","l":"l___zpyV2","static":"static___enXXJ","textShieldImgV2":"textShieldImgV2___CpDe9"};